import { useState } from "react";
import { firestore, auth } from "../../../../firebase";
import {
  Card,
  CardContent,
  Button,
  TextField,
  Stack,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Grid,
  Typography,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify"; // then this

const BstkHorizontalWall = ({ formData, setFormData }) => {
  const [horizontalWallOverlay, setHorizontalWallOverlay] = useState("");
  const [horizontalWallCoating, setHorizontalWallCoating] = useState("");
  const [horizontalWallStructure, setHorizontalWallStructure] = useState("");
  const [horizontalWallCeiling, setHorizontalWallCeiling] = useState("");
  const [horizontalWallSurface, setHorizontalWallSurface] = useState("");
  const [horizontalWallNotes, setHorizontalWallNotes] = useState("");

  // const handleSubmit = (e) => {
  //   if (
  //     horizontalWallOverlay &&
  //     horizontalWallCoating &&
  //     horizontalWallStructure &&
  //     horizontalWallCeiling &&
  //     horizontalWallSurface &&
  //     horizontalWallNotes
  //   ) {
  //     const newSite = {
  //       horizontalWallOverlay,
  //       horizontalWallCoating,
  //       horizontalWallStructure,
  //       horizontalWallCeiling,
  //       horizontalWallSurface,
  //       horizontalWallNotes,
  //     };
  //     firestore.collection("sites").add(newSite);
  //     setHorizontalWallCoating("");
  //     setHorizontalWallStructure("");
  //     setHorizontalWallCeiling("");
  //     setHorizontalWallSurface("");
  //     setHorizontalWallNotes("");
  //     setHorizontalWallOverlay("");
  //   }
  // };
  return (
    // <form onSubmit={handleSubmit} noValidate autoComplete="off">
    <>
      <Card sx={{ marginBottom: "30px" }}>
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <Typography variant="h5">
                Encoding the horizontal wall (Before works)
              </Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl fullWidth>
                  <InputLabel id="horizontalWallOverlay-label">
                    Overlay
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="horizontalWallOverlay-label"
                    label="Overlay"
                    id="horizontalWallOverlay"
                    value={formData.horizontalWallOverlay}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        horizontalWallOverlay: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="pierre-naturelle">
                      pierre naturelle
                    </MenuItem>
                    <MenuItem value="beton-poli">béton poli</MenuItem>
                    <MenuItem value="parquet-lamine">parquet laminé</MenuItem>
                    <MenuItem value="parquet-massif-colle">
                      parquet massif collé
                    </MenuItem>
                    <MenuItem value="parquet-massif-flottant">
                      parquet massif flottant
                    </MenuItem>
                    <MenuItem value="resilient-mince">
                      résilient* mince
                    </MenuItem>
                    <MenuItem value="resilient-multicouches">
                      résilient* multi-couches
                    </MenuItem>
                    <MenuItem value="tapis-mince">tapis mince</MenuItem>
                    <MenuItem value="tapis-multi-couches">
                      tapis multi-couches
                    </MenuItem>
                    <MenuItem value="vynil-liege-caoutchouc">
                      vynil, liège, caoutchouc, ...
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="horizontalWallCoating-label">
                    Coating
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="horizontalWallCoating-label"
                    label="Coating"
                    id="horizontalWallCoating"
                    value={formData.horizontalWallCoating}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        horizontalWallCoating: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="chape de ciment">chape de ciment</MenuItem>
                    <MenuItem value="chape anhydrite">chape anhydrite</MenuItem>
                    <MenuItem value="Simples plaques, sur couche résiliente">
                      Simples plaques, sur couche résiliente
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur bandes résilientes (sans absorbant)">
                      Simples plaques, sur bandes résilientes (sans absorbant)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur bandes résilientes (avec absorbant)">
                      Simples plaques, sur bandes résilientes (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur plots résilients (sans absorbant)">
                      Simples plaques, sur plots résilients (sans absorbant)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur plots résilients (avec absorbant)">
                      Simples plaques, sur plots résilients (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur couche résiliente">
                      Multi-plaques, sur couche résiliente
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur bandes résilientes (sans absorbant)">
                      Multi-plaques, sur bandes résilientes (sans absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur bandes résilientes (avec absorbant)">
                      Multi-plaques, sur bandes résilientes (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur plots résilients (sans absorbant)">
                      Multi-plaques, sur plots résilients (sans absorbant
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur plots résilients (avec absorbant)">
                      Multi-plaques, sur plots résilients (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Solution 'Lewis' avec micro-béton, posée sur structure">
                      Solution 'Lewis' avec micro-béton, posée sur structure
                    </MenuItem>
                    <MenuItem value="Solution 'Lewis' avec micro-béton, sur couche résiliente">
                      Solution 'Lewis' avec micro-béton, sur couche résiliente
                    </MenuItem>
                    <MenuItem value="Solution 'Lewis' avec micro-béton, sur bandes résilientes">
                      Solution 'Lewis' avec micro-béton, sur bandes résilientes
                    </MenuItem>
                    <MenuItem value='Solution "Keep Silence"'>
                      Solution "Keep Silence"
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="horizontalWallStructure-label">
                    Structure
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="horizontalWallStructure-label"
                    label="Structure"
                    id="horizontalWallStructure"
                    value={formData.horizontalWallStructure}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        horizontalWallStructure: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="prédalles + couche de compression">
                      prédalles + couche de compression
                    </MenuItem>
                    <MenuItem value="hourdis béton + couche de compression">
                      hourdis béton + couche de compression
                    </MenuItem>
                    <MenuItem value="poutrains-claveaux + couche de compression">
                      poutrains-claveaux + couche de compression
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol et de plafond (sans absorbant)">
                      olives en bois, sans plaques de sol et de plafond (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol et de plafond (avec absorbant)">
                      solives en bois, sans plaques de sol et de plafond (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, sans plaques de sol, avec plaques de
                      plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, sans plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, sans plaques de sol, avec plaques de
                      plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (sans absorbant)">
                      solives en bois, avec simples plaques de sol, sans plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, sans plaques de plafond (avec absorbant)">
                      solives en bois, avec simples plaques de sol, sans plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (sans absorbant)">
                      solives en bois, avec multi-plaques de sol, sans plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, sans plaques de plafond (avec absorbant)">
                      solives en bois, avec multi-plaques de sol, sans plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, avec simples plaques de sol, avec plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec simples plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, avec simples plaques de sol, avec plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (sans absorbant)">
                      solives en bois, avec multi-plaques de sol, avec plaques
                      de plafond (sans absorbant)
                    </MenuItem>
                    <MenuItem value="solives en bois, avec multi-plaques de sol, avec plaques de plafond (avec absorbant)">
                      solives en bois, avec multi-plaques de sol, avec plaques
                      de plafond (avec absorbant)
                    </MenuItem>
                    <MenuItem value="autre (semi-lourd)">
                      autre (semi-lourd)
                    </MenuItem>
                    <MenuItem value="autre (léger)">autre (léger)</MenuItem>
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <InputLabel id="horizontalWallCeiling-label">
                    Ceiling
                  </InputLabel>
                  <Select
                    fullWidth
                    // error={siteHousingTypeError}
                    labelId="horizontalWallCeiling-label"
                    label="Ceiling"
                    id="horizontalWallCeiling"
                    value={formData.horizontalWallCeiling}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        horizontalWallCeiling: e.target.value,
                      })
                    }
                  >
                    <MenuItem value="Enduit (plâtre, ciment,...)">
                      Enduit (plâtre, ciment,...)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur ressorts métalliques">
                      Simples plaques, sur ressorts métalliques
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur structure métallique suspendue (sans absorbant)">
                      Simples plaques, sur structure métallique suspendue (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur structure métallique suspendue (avec absorbant)">
                      Simples plaques, sur structure métallique suspendue (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Simples plaques, sur structure métallique indépendante (avec absorbant)">
                      Simples plaques, sur structure métallique indépendante
                      (avec absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur ressorts métalliques">
                      Multi-plaques, sur ressorts métalliques
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur structure métallique suspendue (sans absorbant)">
                      Multi-plaques, sur structure métallique suspendue (sans
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur structure métallique suspendue (avec absorbant)">
                      Multi-plaques, sur structure métallique suspendue (avec
                      absorbant)
                    </MenuItem>
                    <MenuItem value="Multi-plaques, sur structure métallique indépendante (avec absorbant)">
                      Multi-plaques, sur structure métallique indépendante (avec
                      absorbant)
                    </MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={2}>
                <FormControl sx={{}} variant="outlined">
                  <OutlinedInput
                    id="horizontalWallSurface"
                    value={formData.horizontalWallSurface}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        horizontalWallSurface: e.target.value,
                      })
                    }
                    endAdornment={
                      <InputAdornment position="end">m2</InputAdornment>
                    }
                    aria-describedby="horizontalWallSurface"
                    inputProps={{
                      "aria-label": "surface",
                    }}
                  />
                </FormControl>

                <TextField
                  fullWidth
                  id="HorizontalWallNotes"
                  label="Additional Notes"
                  multiline
                  rows={4}
                  value={formData.horizontalWallNotes}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      horizontalWallNotes: e.target.value,
                    })
                  }
                />
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};

export default BstkHorizontalWall;
